const zh = {
  contact: {
    heroHeading: '联系我们',
    heroSub: '无论您是购房、卖房还是投资 — 我们的团队将全程支持您。',
    expertsBadge: '认识我们的专家',
    expertsHeading: 'Victory Homes 团队',
    officeLabel: '办公室地址',
    phoneLabel: '电话号码',
    phoneOffice: '办公室',
    phoneWA: '电话 / WhatsApp',
    emailLabel: '发邀电子邮件',
    followLabel: '关注我们',
    formHeading: '发送信息',
    formSub: '填写表格，我们将在 24 小时内回复您。',
    fieldName: '您的姓名 *',
    fieldEmail: '电子邮件地址 *',
    fieldPhone: '电话号码',
    fieldSubject: '主题',
    fieldMessage: '您的留言 *',
    sendBtn: '发送信息',
    sentBtn: '\u2713 已发送!',
    thankYou: '感谢！我们将在 24 小时内回复。',
  },
  mort: {
    heroBadge: '按揭服务',
    heroLine1: '阿拉伯联合酋按揭解决方案',
    heroAccent: '为您定制',
    heroSub: '计算您的月还额，查询资格，探索来自 15+ 阿拉伯联合酋银行的按揭产品 — 一展尽收。',
    tabCalc: '📊 按揭计算器',
    tabElig: '✅ 资格查询',
    loanParams: '贷款参数',
    propertyValue: '房产价值',
    downPayment: '首付款',
    annualRate: '年利率',
    loanTenure: '贷款期限',
    years: (n) => `${n} 年`,
    minDown: '20%（最低）',
    maxUAE: '25 年（阿拉伯联合酋最高）',
    monthlyEMI: '月还金额',
    loanAmount: '贷款金额',
    totalInterest: '总利息',
    totalPayable: '应还总额',
    principalVsInterest: '本金与利息',
    principal: '本金',
    interest: '利息',
    compareRates: '🏦 比较阿拉伯联合酋银行利率',
    amortSchedule: '📅 年度还款计划表',
    basedOnLoan: (amt, yrs) => `基于您 ${yrs} 年 AED ${amt} 的贷款。利率仅供参考。`,
    bankCol: '银行',
    fixedRate3yr: '固定利率(3年)',
    variableEIBOR: '浮动(EIBOR+)',
    monthlyEMIFixed: '月还(固定)',
    totalCost: '总费用',
    eibor3mNote: (rate) => `* EIBOR 3M: ${rate}%（参考利率）。浮动利率定期重置。`,
    yearCol: '年份',
    principalPaid: '已还本金',
    interestPaid: '已还利息',
    balanceRemaining: '剩余贷款',
    yearRow: (n) => `第 ${n} 年`,
    financialProfile: '您的财务概况',
    residencyStatus: '居住状态',
    residencyOpts: [
      { value: 'resident',    label: '🏠 阿拉伯联合酋居民',   desc: '80% LTV · 25年' },
      { value: 'national',    label: '🇦🇪 阿拉伯联合酋公民',  desc: '85% LTV · 25年' },
      { value: 'nonresident', label: '✈️ 非居民',  desc: '50% LTV · 15年' },
    ],
    yourAge: '您的年龄',
    ageUnit: '岁',
    monthlySalary: '月薪 (AED)',
    otherIncome: '其他月收入',
    existingEMI: '现有贷款EMI (AED/月)',
    creditCard: '信用卡额度 (AED)',
    ccNote: '银行将额度的5%计入月负担',
    assumedRate: '预设利率',
    checkBtn: '🔍 查询资格',
    fillDetails: '填写资料',
    fillDesc: '基于阿拉伯联合酋中央银行 DBR 规则，计算您在各银行可内的最高按揭金额。',
    errTitle: '无法计算资格',
    errDesc: '您的现有负债可能超过DBR 50%限制，请联系我们的顾问。',
    maxLoan: '最高贷款额度',
    maxProperty: '最高房产价值',
    minDownPay: '最低首付款',
    maxTenure: '最长贷款期限',
    maxEMI: '最高允许月还',
    dbrTitle: '阿拉伯联合酋中央银行 DBR 分析',
    grossIncome: '月总收入',
    existingObligs: '现有负债',
    dbrHeadroom: 'DBR 剩余空间(50%)',
    ltvApplied: '适用 LTV',
    dbrNote: '结果仅供参考。实际资格取决于银行评估和信用记录。',
    readyApply: '准备申请？',
    readyApplyDesc: '我们的顾问将帮您在 15+ 阿拉伯联合酋银行中获得最优利率。',
    talkAdvisor: '和顾问交流 →',
    servicesBadge: '我们的服务',
    servicesHeading: '一展尽收，无需到处屋山',
    servicesSub: 'Victory Homes 与阿拉伯联合酋主要银行合作，提供透明、高效的按揭服务。',
    services: [
      { icon: '🏠', title: '住宅按揭', desc: '以主要银行的第一手利率资助您在UAE的理想之居。' },
      { icon: '✈️', title: '非居民按揭', desc: '居住UAE境外感兴趣投资？我们为海外购房者安排按揭，最高LTV 50%。' },
      { icon: '🔄', title: '转贷 / 权益释放', desc: '对现有按揭负担过重？换行应战，节省大量利息。' },
      { icon: '🏗️', title: '土地与建屋', desc: '针对有地购买和建屋项目的专业元流工具。' },
      { icon: '📋', title: '唔货资格评估', desc: '评估您的资料并提供超过5家银行的预资格证明书。' },
      { icon: '👤', title: '专属按揭顾问', desc: '每位客户有专属顾问，全程跟踪直至成功放款。' },
    ],
    ctaHeading: '准备迈出下一步？',
    ctaSub: '我们的按揭顾问随时待命，帮您谈到最优条件。免费和无约束和顾问。',
    ctaBtn: '预约免费和顾问 →',
  },
  offplan: {
    heroBadge: '\u2726 迪拜期房房产',
    heroLine1: '在城市行动之前',
    heroAccent: '率先投资。',
    heroSub: '独家抢先认购迪拜最热门项目。以当前价格锁定优质房源——市场行动之前。',
    browseBtn: '浏览项目',
    advisorBtn: '咨询顾问',
    statGrowth: '平均资本增长',
    statVisa: '黄金签证门槛',
    statComm: '买方佣金',
    whyBadge: '为什么选择期房',
    whyHeading: '精明投资者的最佳选择',
    why: [
      { icon: '\ud83d\udcb0', title: '低入地价格', desc: '以预售价肥得——通常比交屋后市场价倦 20–30%。' },
      { icon: '\ud83d\udcc5', title: '灵活付款方式', desc: '开发商提供 40/60 或 20/80 分期付款——分敢建设期投资压力。' },
      { icon: '\ud83d\udcc8', title: '资本增值', desc: '迪拜期房历史上从开盘到交屋增値 30–50%。' },
      { icon: '\ud83e\ude99', title: '黄金签证资格', desc: 'AED 200万+ 房产可申请 10 年期 UAE 黄金签证。' },
    ],
    featuredBadge: '精选项目',
    featuredHeading: '精心筛选的期房项目',
    catalogueLink: '申请完整目录 \u2192',
    showingOf: (shown, total) => `显示 ${total} 个项目中的 ${shown} 个`,
    noMatchTitle: '未找到匹配房产',
    noMatchDesc: '请尝试扩大搜索范围或调整筛选条件。',
    clearFilters: '清除所有筛选',
    communitiesBadge: '探索社区',
    communitiesHeading: '迪拜最受欢迎的区域',
    seeListings: '查看所有房源 \u2192',
    locations: [
      { name: 'Downtown', desc: ['位于迬拜最标志性地标区的中心， Downtown 芙荠精能都市生活。', '宽敎大厅、全景露台，尽览城市最著名地标的无阔美景。'] },
      { name: 'Palm Jumeirah', desc: ['棕林岛融合了文化传承与现代优雅。', '怎意设计的居所与岬静室外空间组合而成社区之美。'] },
      { name: 'Marina', desc: ['迪拜渻海滨贡付了聊鄆都市汎与滨水移居的完美融合。', '私人船坞、晟色步行广场及全景无障础水景。'] },
      { name: 'Dubai Hills', desc: ['迪拜山丘将自然与城市优雅无缝融合。', '健康、优雅、社区感兼备的生活方式。'] },
      { name: 'Arabian Ranches', desc: ['潮流装修别墅、桃李成跡的街道和空旷地带来叁破天际的隐私与脸静。', '高岔球场、社区公园与家庭居住气息。'] },
    ],
  },
  sell: {
    heroBadge: '登记您的房产',
    heroHeadline: '与我们合作',
    heroAccent: 'Victory Homes',
    heroSub: '与我们的专业团队登记您的房产出售或出租。我们处理从估价到成交的一切。',
    formBadge: '展示房产业主',
    formHeading: '在我们这里登记您的房产',
    formSub: '填写表格，我们的层次团队将处理一切——从估价到成交。',
    tabSell: '🏷️ 出售',
    tabRent: '🔑 出租',
    sectionContact: '联系详情',
    sectionProperty: '房产详情',
    sectionDocs: '法律文件',
    sectionPhotos: '房产照片',
    fullName: '姓名',
    email: '电子邮箱',
    phone: '电话号码',
    whatsapp: 'WhatsApp（可选）',
    propertyType: '房产类型',
    selectType: '— 选择类型 —',
    emirate: '酷等地',
    selectEmirate: '— 选择酷等地 —',
    community: '社区 / 区域',
    subCommunity: '子社区 / 楼栈',
    bedrooms: '卧室',
    bathrooms: '浴室',
    select: '— 选择 —',
    areaSqFt: '面积（平方英尺）',
    floor: '楼层',
    furnishing: '装修情况',
    completion: '完工状态',
    ready: '已现房',
    offPlan: '期房',
    askingPrice: '挂牌价',
    rentAmount: '租金（每年）',
    priceHint: '输入金额，不需逗号。价格应反映当前市场价值。',
    youtubeLink: 'YouTube 视频链接',
    youtubeHint: '添加 YouTube 链接以展示您的房产（可选）',
    description: '房产描述',
    descPlaceholder: '描述您的房产——特点、景观、装修、附近设施…',
    docsIntro: '这些文件验证产权并促进顺利登记。所有文件安全存储。',
    titleDeed: '产权证书',
    titleDeedHint: '官方产权证书。',
    floorPlan: '平面图',
    floorPlanHint: '建筑平面图。',
    passport: '护照副本',
    passportHint: '房产主的有效护照。',
    privacy: '隐私有保障。您的文件已加密，仅授权团队可访问。',
    photosLabel: '房产照片',
    photosHint: '最多20张 — JPG, PNG, WEBP。第一张将为封面。',
    photosIntro: '优质照片能大幅增加和询。对每个房间拍广角亮度照片。',
    dragDrop: '拖放或',
    browse: '浏览',
    accepted: '支持 PDF, JPG, PNG',
    clickReplace: '点击替换',
    dropPhotos: '将照片拖放到这里',
    orClickBrowse: '或点击浏览',
    upTo20: '最多20张图片',
    photosAdded: (n) => `已添加 ${n} 张照片`,
    submitSale: '🚀 提交出售登记',
    submitRental: '🚀 提交出租登记',
    submitting: '⏳ 提交中…',
    termsNotice: '提交即表示您同意 Victory Homes 的服务条款。',
    successTitle: '登记已提交！',
    successDesc: '我们的团队将审核并在',
    successHours: '24小时内联系您',
    submitAnother: '再次提交',
    errName: '姓名为必项',
    errEmail: '需要有效电子邮箱',
    errPhone: '电话号码为必项',
    errPropType: '请选择房产类型',
    errEmirate: '请选择酷等地',
    errPrice: '挂牌价为必项',
    errRent: '租金为必项',
    errPhotos: '至少需要一张房产照片',
  },
  props: {
    heroBadge: '阿联酌房产',
    listingCount: (n) => `${n} 个房源可用`,
    tabBuy: '购买',
    tabRent: '租赁',
    portfolio: '我们的投资组合',
    forSale: '出售房产',
    forRent: '出租房产',
    listYourProperty: '登记您的房产 →',
    buy: {
      badge: '出售房产',
      headline: '找到您的',
      accent: '理想购房',
      sub: '探索由我们専家团队精心筛选的阿联酌验证房源。',
    },
    rent: {
      badge: '出租房产',
      headline: '找到您的',
      accent: '理想租房',
      sub: '浏览 Victory Homes 精心筛选的迪拜优质出租房源。',
    },
    enquireNow: '立即和询 →',
    noMatchTitle: '没有符合您筛选条件的房源',
    noMatchDesc: '请调整预算、类型或区域以查看更多结果。',
    clearFilters: '清除所有筛选',
    emptyBuy: '目前无出售房源',
    emptyRent: '目前无出租房源',
    emptyDesc: () => '我们的房源组合定期更新——请稍后再查或直接联系我们。',
    speakAgent: '和经纪人沟通 →',
    listProp: '登记您的房产',
    exploreOther: '查看其他房源',
    otherForSale: '其他可售房源',
    otherForRent: '其他可租房源',
    otherDesc: '正在归档该类别房源，以下是我们组合中的其他房源供您参考。',
    ctaBadge: '准备好了吗？',
    ctaHeading: '您有房产要登记吗？',
    ctaDesc: '我们的专业经纪人处理从估价到成交的一切。立即在 Victory Homes 登记您的房产。',
    contactUs: '联系我们',
  },
  featured: {
    tag: '独家房产',
    heading: '与Emirates一起探索独家房产',
    desc: '与Emirates共同发现最优质豪华住宅和顶级房产投资机遇。踏入您应得的生活方式。',
  },
  partners: {
    tag: '我们的合作伙伴',
    heading: '阿联酌顶尖开发商旗下优质房产',
    learnMore: '了解更多',
    learnMoreArrow: '了解更多 →',
    oasis: { title: 'Oasis 花园别墅', desc: '带有私家花园、阴凉庁院和自然灵感布局的宽敌当代庄园——专为宁静、高雅和家庭化生活而打造。' },
    ghaf:  { title: '迪拜 Ghaf Woods', desc: '低密度环保社区，配备步行友好空间和山崃绿木，专为健康和可持续生活设计。' },
    nad:   { title: '纳德尔希巴', desc: '小区远离喧嘉，水清木秀，共享私密和开方空间，采光充山崾和迪拜主要地标近在和谐住宅区。' },
    district: { title: '壹号区，迪拜', desc: '水晶泡环箱和郁郁葱葱的绿地之间山连别夫和豪宅籍口小镇，层次感进张齐全怡充满加超豪华社区——标志真正尖顶私密和尊贵。' },
  },
  media: {
    tag: '媒体报道',
    heading: '我们相关新闻报道',
    readArticle: '阅读文章',
  },
  newsletter: {
    badge: '保持关注',
    heading: '掌握迪拜房产市场动态',
    desc: '独家房源、市场洞察和投资机遇直接发送到您的邮箖——在市场上峰之前。',
    placeholder: '输入您的邮箕地址',
    btn: '订阅 →',
    privacy: '🔒 没有垃圾邮件。随时取消订阅。您的数据安全无忧。',
    success: '✓ 订阅成功！欢迎加入 Victory Homes 社区。',
    error: '请输入有效的邮箕地址。',
  },
  nav: {
    home: '首页', properties: '房产', buy: '🏡 购买', rent: '🔑 租赁',
    sellRent: '出售/出租', offplan: '期房', services: '服务',
    holidayHomes: '度假屋', propertyManagement: '物业管理',
    fitOut: '装修、搬家及包装',
    legalAssistance: '法律援助',
    valuation: '房产估价',
    calculators: '房贷',
    transactions: '交易',
    mortgage: '房贷计算器', contact: '联系我们', roiCalc: '回报率计算器',
    areaIntelligence: '区域智能分析',
  },
  valuation: {
    heroTitle: '免费市场房产估价',
    heroDesc: '考虑出售？从我们的专家那里获得即时的、数据驱动的房产当前市场价值评估。',
    successTitle: '已收到请求！',
    successDesc: '我们的估价专家将审查您的房产详细信息，并很快与您联系。',
    submitAnother: '提交另一个',
    fullName: '全名 *',
    phone: '电话号码 *',
    email: '电子邮件地址',
    propType: '房产类型 *',
    selectType: '选择类型',
    location: '位置 / 社区 *',
    locPlaceholder: '例如：迪拜码头',
    bedrooms: '卧室',
    select: '选择',
    area: '建筑面积（平方英尺）',
    areaPlaceholder: '例如：1500',
    submit: '获取我的免费估价',
    submitting: '提交中...',
    fail: '提交请求失败。请重试。'
  },
  recentlySold: {
    title: '最近售出房产',
    desc: '我们最新成功交易的精选。体验Victory Homes的与众不同。',
    badge: '已售出',
    beds: '床'
  },
  trust: {
    clientStories: '客户故事',
    hearFromClients: '听听我们的客户怎么说',
    videoUnavailable: '视频不可用',
    trackRecord: '业绩记录',
    provenSuccess: '已证明的成功'
  },
  areaIntelligence: {
    heroBadge: '迪拜区域智能分析',
    heroLine1: '数据驱动的洞察，覆盖',
    heroAccent: '迪拜每一个区域。',
    heroSub: '探索迪拜最热门社区的价格趋势、租金回报率和 AI 投资分析。',
    modeBuy: '购买',
    modeRent: '租赁',
    modeOffplan: '期房',
    filterTitle: '筛选与指标',
    heatmapLabel: '地图指标',
    chartAreasLabel: '图表区域',
    selectAll: '全选',
    selectNone: '清空',
    loading: '正在加载区域数据…',
    mapsKeyMissing: '需要 Google Maps API 密钥',
    mapsKeyHint: '请在 .env 文件中添加 VITE_GOOGLE_MAPS_API_KEY，然后重新加载。',
    mapFailedLoad: '地图加载失败。请检查 API 密钥。',
    mapLoading: '地图加载中…',
    legendSelectedArea: '⬤ 已选区域',
    legendSelectedDesc: '白色气泡 = 您的当前选择',
    legendLow: { avgPrice: '较低价格', rentalYield: '较低回报率', demandScore: '低需求', avgPricePerSqft: '较低单价' },
    legendHigh: { avgPrice: '较高价格', rentalYield: '较高回报率', demandScore: '高需求', avgPricePerSqft: '较高单价' },
    activeProjects: '在售项目',
    nearbyLandmarks: '📍 附近地标',
    kpiAvgPrice: '平均价格',
    kpiPricePerSqft: '单价/平方英尺',
    kpiGrossYield: '毛租金回报',
    kpiDemandScore: '需求指数',
    aiInsightTitle: '✦ AI 市场分析',
    aiGenerate: '生成 →',
    aiAnalysing: '正在分析市场数据…',
    aiKeyMissing: '请在 backend/.env 中添加 GEMINI_API_KEY 以启用 AI 分析。',
    aiPrompt: '点击"生成"获取该区域的 AI 驱动投资分析。',
    browseOffplan: (name) => `浏览 ${name} 的期房项目 →`,
    viewResale: '查看二手房源 →',
    priceTrendBadge: '价格趋势',
    priceTrendTitle: '12个月每平英尺价格 (AED)',
    priceTrendSub: '基于市场数据汇总的12个月趋势',
    rentalYieldBadge: '租金回报率',
    rentalYieldTitle: '各区域毛租金回报率 (%)',
    rentalYieldSub: '基于年均租金与平均购买价格的对比',
    tooltipYield: (val, name) => [`${val}% 毛回报率`, name],
    comparisonBadge: '区域对比',
    comparisonTitle: '最多对比 3 个区域',
    comparisonSub: '在下方选择区域进行并排比较',
    comparisonPlaceholder: '在上方选择区域以查看对比',
    colMetric: '指标',
    rowAvgPrice: '平均价格',
    rowPricePerSqft: '单价/平方英尺',
    rowGrossYield: '毛租金回报',
    rowDemandScore: '需求指数',
    rowActiveProjects: '在售项目',
    rowMinEntry: '最低入市价',
    rowMaxPrice: '最高价格',
    best: '最佳',
    metricAvgPrice: '平均价格',
    metricRentalYield: '租金回报率',
    metricDemand: '需求',
    metricPricePerSqft: '单价/平方英尺',
  },
  hero: {
    slide1H: '智能数据、专业指导与人性信任的完美融合。',
    slide1P: 'Victory Homes 是阿联酋首家帮助人们在寻找房屋之前先发现理想生活的经纪公司。',
    slide1Btn: '立即探索',
    slide2H: '独家海滨豪宅。',
    slide2P: '在世界最具标志性的人工岛——棕榈岛，体验无与伦比的奢华生活。',
    slide2Btn: '探索棕榈岛',
    slide3H: '未来生活，完美匹配。',
    slide3P: '借助环境数据和预测建模，我们为客户匹配迪拜滨海区的前沿社区。',
    slide3Btn: '发现滨海区',
    slide4H: '寻找生活，而不只是房子。',
    slide4P: '在壹号区的传奇水晶泻湖和绿草如茵的环境中，探索您的私人天堂。',
    slide4Btn: '查看壹号区',
  },
  stats: {
    impact: '我们的业务影响',
    sold: '2020–2024年总销售额',
    lifetime: '历史累计销售量',
    current: '当前挂牌量',
  },
  sellTestimonials: {
    tag: '客户评价',
    heading: '与 Victory Homes 合作，快速高效出售房产',
    desc: '透明流畅的流程，最大化您的房产价值，减少您的压力。',
  },
  team: {
    tag: '我们的团队',
    heading: '与阿联酋顶级房产专家携手合作',
    desc: '认识我们 Victory Homes 的专业经纪人——随时准备指导您完成每一步。',
    btn: '认识全体团队 →',
  },
  goldenVisa: {
    badge: '🇦🇪 投资者福利',
    heading: '阿联酋黄金签证',
    headingGold: '通过房产获取',
    desc: '在阿联酋投资价值<strong>200万迪拉姆及以上</strong>的房产，解锁<strong>10年可续签阿联酋居留签证</strong>——惠及您和家人。',
    cta: '检查我的资格 →',
    benefitsHeading: '黄金签证为何具有颠覆性意义',
    benefitsSubheading: '阿联酋黄金签证打开了大多数国家无法提供的机遇之门。',
    stepsHeading: '如何获得黄金签证',
    stepsSubheading: '4个简单步骤——我们的团队全程陪同',
    stepCtaHeading: '准备好申请阿联酋黄金签证了吗？',
    stepCtaDesc: '我们的顾问将根据您的预算和目标推荐合适的房产。',
    stepCtaBtn: '与顾问交谈',
    yearVisa: '年签证',
    minValue: '最低房产价值',
    benefits: {
      b1t: '10年居留权', b1d: '投资200万迪拉姆及以上的房产，即可获得10年阿联酋黄金签证。',
      b2t: '家庭担保', b2d: '配偶、子女和父母均可纳入同一签证，无需单独申请。',
      b3t: '无需担保人', b3d: '无需雇主或本地担保人，即可在阿联酋生活、工作和学习。',
      b4t: '无限续签', b4d: '只要持有符合条件的房产，黄金签证将自动续签，无限制。',
      b5t: '全球流动性', b5d: '享受多次入境特权，并可在阿联酋境外长期居住而不影响签证有效期。',
      b6t: '投资安全性', b6d: '阿联酋房产是顶级资产类别——将精英居留权与强劲资本增值潜力相结合。',
    },
    steps: {
      s1: '购买价值200万迪拉姆及以上的房产',
      s2: '从迪拜土地局获取房产证',
      s3: '在我们团队的指导下通过ICA或GDRFA提交申请',
      s4: '领取10年黄金签证及阿联酋身份证',
    },
  },
  blog: {
    tag: '博客',
    heading: '阿联酋房产博客的见解与资讯',
    desc: '获取迪拜房产市场的最新新闻、技巧和专家洞见。',
    readMore: '继续阅读',
  },
  evo: {
    statsBadge: '数字中的迪拜',
    statsHeading: '迪拜房产市场的演变',
    statsDesc: '仅用二十年，从区域贸易港口跻身全球最具活力的房产市场。',
    timelineBadge: '发展历程',
    timelineHeading: '迪拜如何成为全球第一房产投资目的地',
    timelineCTA: '想了解迪拜市场的走向？',
    timelineBtn: '与市场专家交流 →',
    stats: {
      s1l: '2024年房产交易量', s2l: '2024年迪拉姆总销售额',
      s3l: '自2020年以来的房价增长', s4l: '在迪拜定居的国籍数量',
    },
    timeline: {
      t1t: '自由持有法通过', t1d: '迪拜允许外国人在指定自由持有区购置房产，引发首波投资热潮。',
      t2t: '天际线蜕变', t2d: '哈利法塔开放，迪拜成为全球最广为人知的现代化城市。',
      t3t: '黄金签证推出', t3d: '阿联酋启动10年黄金签证计划，带动200万迪拉姆以上住宅需求激增。',
      t4t: '破纪录市场', t4d: '疫情后复苏驱动价格上涨逾60%，跻身全球表现最佳的房产市场。',
      t5t: '再创历史新高', t5d: '迪拜录得96,000余笔交易，总值4110亿迪拉姆，打破所有历史年度纪录。',
      t6t: '迪拜2040城市规划', t6d: '规划目标：绿地翻倍、5个城市中心、2040年人口达580万。',
    },
  },
  txn: {
    badge: '由 DXBinteract 提供支持',
    heading: '迪拜交易报告',
    desc: '访问迪拜土地局实时数据——每笔销售有记录，每个价格有追踪，每个趋势有图示。',
    live: '实时 DLD 数据',
    openPlatform: '打开完整平台 ↗',
    viewReport: '查看报告 →',
    ctaHeading: '需要特定区域的个性化交易报告？',
    ctaDesc: '我们的顾问可以提取区域具体数据并为您的投资作出解读。',
    ctaBtn: '咨询顾问',
    reports: {
      r1l: '每日报告', r1d: 'DLD记录的每笔交易——每日更新。',
      r2l: '每周报告', r2d: '每周销量、价格及区域趋势汇总。',
      r3l: '每月报告', r3d: '对所有物业类型月度表现的深入剖析。',
      r4l: '季度报告', r4d: '季度对比分析：价格变动、热门区域、投资者活动。',
      r5l: '年度报告', r5d: '全年市场回顾：创纪录成交、新兴社区、展望预测。',
      r6l: '区域价格热图', r6d: '显示迪拜各社区每平方英尺价格的交互式热力图。',
    },
  },
  cta: {
    buying: '开始购买', selling: '开始出售', contact: '联系我们',
    findOut: '了解更多', comingSoon: '即将推出',
  },
  offplanPromo: {
    badge: '期房房产',
    heading: '新项目与独家预售优惠',
    desc: '在迪拜最抢手的期房项目中锁定房源——趁售完之前。200万迪拉姆起即可获黄金签证资格。',
    btn: '探索期房 →',
  },
  topCommunities: {
    badge: '市场洞察',
    heading: '迪拜热门社区',
    desc: '为投资者和自住买家提供的战略洞察 (2026-2027)',
    tabs: {
      roi: '投资回报率(ROI)领跑者',
      villas: '别墅与联排别墅',
      budget: '按预算分类',
      strategy: '投资策略指南'
    },
    roi: {
      title: '最高ROI社区 (2026–2027)',
      desc: '这些区域持续提供强劲的租金回报和资本增值。',
      list: [
        '朱美拉村圈 (JVC)',
        '迪拜南城 (Dubai South)',
        '阿让 (Arjan)',
        '迪拜硅谷绿洲 (Dubai Silicon Oasis)',
        '迪拜体育城 (Dubai Sports City)',
        '商业湾 (Business Bay)',
        '迪拜码头 (Dubai Marina)'
      ],
      insightTitle: '核心洞察',
      insights: [
        'JVC + Arjan = 最高租金回报 (6–9%)',
        'Marina + Business Bay = 回报略低，但资本增值更强且流动性好'
      ]
    },
    villas: {
      title: '最佳别墅/联排别墅社区',
      desc: '主要面向自住买家、家庭和长期居住。',
      list: [
        '迪拜山庄 (Dubai Hills Estate)',
        '阿拉伯牧场 (Arabian Ranches)',
        '蒂拉尔阿加夫 (Tilal Al Ghaf)',
        '达马克山庄 (DAMAC Hills)',
        '山谷社区 (The Valley)',
        '穆东 (Mudon)',
        '城市广场 (Town Square)'
      ],
      insightTitle: '核心洞察',
      insights: [
        '迪拜山庄 = 最佳平衡 (地段 + 品质)',
        'Tilal Al Ghaf = 高端生活方式社区',
        'Town Square / The Valley = 入门级别墅'
      ]
    },
    budget: {
      title: '按预算划分的最佳社区',
      categories: [
        {
          name: '入门级',
          range: '50万 – 90万 迪拉姆',
          areas: ['国际城 (International City)', '迪拜南城', '发现花园 (Discovery Gardens)', '迪拜生产城', 'Liwan'],
          bestFor: '首次投资者，最高租金收益'
        },
        {
          name: '中端市场',
          range: '90万 – 200万 迪拉姆',
          areas: ['朱美拉村圈 (JVC)', '阿让 (Arjan)', '阿尔富简 (Al Furjan)', '迪拜硅谷绿洲', '迪拜云溪港 (Dubai Creek Harbour)'],
          bestFor: 'ROI与资本增值的平衡'
        },
        {
          name: '中高端 / 次顶配',
          range: '200万 – 500万 迪拉姆',
          areas: ['商业湾', '迪拜码头', '迪拜山庄', '朱美拉棕榈岛 (入门级房源)'],
          bestFor: '流动性强 + 二手房需求旺盛'
        },
        {
          name: '奢华级',
          range: '500万+ 迪拉姆',
          areas: ['迪拜市中心 (Downtown)', '朱美拉棕榈岛', '阿联酋山庄 (Emirates Hills)', '第一区 (District One)', '朱美拉湾岛 (Jumeirah Bay Island)'],
          bestFor: '资本保值 + 顶级资产'
        }
      ]
    },
    strategy: {
      title: '简单投资策略指南',
      guide: [
        { goal: '追求最高ROI', action: 'JVC, Arjan, 迪拜南城' },
        { goal: '追求稳健投资', action: '迪拜山庄, 迪拜码头' },
        { goal: '追求奢华生活及增值', action: '朱美拉棕榈岛, 迪拜市中心 (Downtown)' },
        { goal: '追求家庭自住', action: '阿拉伯牧场, Tilal Al Ghaf' }
      ]
    }
  },
  servicesPage: {
    "heroTag": "Victory 服务",
    "whyChoose": "为什么选择我们的 {service}？",
    "form": {
        "fullName": "姓名",
        "email": "电子邮箱",
        "phone": "联系电话",
        "detailsOpt": "房产/单位详情 (选填)",
        "messageOpt": "补充留言或要求",
        "submitRequest": "提交申请",
        "submitting": "提交中...",
        "successTitle": "申请已收到！",
        "successDesc": "感谢您咨询我们的 {service}。我们的团队将评估您的申请并尽快与您联系。",
        "submitAnother": "提交另一个申请",
        "errors": {
            "nameReq": "请输入您的全名",
            "emailReq": "请输入有效的电子邮件地址",
            "phoneReq": "请输入您的联系电话",
            "failSub": "提交失败，请稍后再试。"
        },
        "placeholders": {
            "name": "如：王小明",
            "email": "you@example.com",
            "phone": "+971 50 123 4567",
            "details": "如：迪拜市中心2卧公寓",
            "message": "我们需要怎么帮助您？"
        }
    },
    "services": {
        "holiday-homes": {
            "title": "度假屋",
            "heroSub": "通过我们优质的短期租赁管理，最大化您的房产收益。",
            "desc": "无忧将您的房产转化为利润丰厚的度假屋。我们负责营销、客务管理和维护，确保您获得顶级收益。",
            "extraDesc": "从布置、专业摄影到各大平台的房源优化，我们专门的策略确保入住率最大化，并提供 24/7 客服支持。",
            "points": [
                "动态定价与营销",
                "24/7 客户支持与礼宾服务",
                "专业保洁服务",
                "每月投资回报率报告",
                "法律与注册协助"
            ],
            "formTitle": "申请度假屋服务",
            "formDesc": "请告诉我们如何协助您实现短期租赁的财务目标。"
        },
        "property-management": {
            "title": "物业管理",
            "heroSub": "全面的管理服务，让您安心并获得稳定收入。",
            "desc": "从租客筛选到维修请求，我们的专业团队以安全且专业的方式管理您的房地产投资。",
            "extraDesc": "我们为您免除房东的日常烦恼。服务涵盖一切事务，包括 Ejari 注册、租金收取、定期检查以及配合处理紧急维修。",
            "points": [
                "全方位租客筛选",
                "租金收取与财务报告",
                "Ejari 与法律合规",
                "定期巡检与维护",
                "纠纷调解服务"
            ],
            "formTitle": "申请物业管理",
            "formDesc": "留下您的详细信息，我们将为您定制管理计划并与您联系。"
        },
        "fit-out": {
            "title": "装修规划服务 (Fit-Out)",
            "heroSub": "用我们世界级的室内设计和装修解决方案升级您的空间。",
            "desc": "为住宅及商业空间提供量身定制的设计、规划和执行方案，无论是豪华别墅升级还是现代办公布局。",
            "extraDesc": "我们经验丰富的设计师与项目经理将在整个过程中与您紧密合作，确保做工精良，符合官方许可并采用高端材料。",
            "points": [
                "量身定制的室内设计概念",
                "空间规划与3D可视化效果",
                "全包工程落地与项目管理",
                "官方审批与许可证申请",
                "定制家具与材料采购"
            ],
            "formTitle": "预约装修咨询",
            "formDesc": "安排一次咨询探讨您对房产的愿景。"
        },
        "legal-assistance": {
          title: "法律援助",
          heroSub: "为阿联酋安全和合规的房地产交易提供专家法律指导。",
          desc: "了解迪拜的房地产法律需要精确性。我们提供全面的法律支持，确保您的房产交易安全无忧。",
          extraDesc: "从彻底的产权验证到确保完全符合RERA规定和尽职调查，我们的专家保护您的利益。",
          points: ["产权验证与尽职调查", "RERA合规与指导", "销售契约清单准备", "购房验证", "争议解决与咨询"],
          formTitle: "申请法律援助",
          formDesc: "提供您的详细信息，我们的法律专家将与您联系。"
        }
    }
},
  footer: {
    letsWork: '携手合作',
    email: '电子邮件',
    callWhatsApp: '电话 / WhatsApp',
    ourLocation: '我们的位置',
    officePhone: '办公室电话',
    tagline: '您在迪拜值得信赖的房产合作伙伴。专注于全阿联酋优质房产的买卖与租赁，每一步都有专业指导。',
    ourServices: '我们的服务',
    usefulLinks: '实用链接',
    copyright: '© 2025 Victory Homes。保留所有权利。',
    serviceLinks: ['新房产', '出售您的房产', '我们的服务', '新闻稿'],
    headline: '我们经验丰富的房产经纪人团队随时待命，随时随地为您服务。',
  },
  offplanDetail: {
    overview: "概述",
    propertyTypes: "房产类型",
    totalUnits: "总单位数",
    handover: "交房时间",
    startingPrice: "起售价",
    startingFrom: "起价",
    paymentPlan: "付款计划",
    location: "地理位置与交通",
    mins: "分钟",
    unitType: "单位类型",
    size: "面积",
    availableOptions: "可用选项",
    getBrochure: "获取宣传册",
    reqDetails: "索取详情",
    dlBrochure: "下载宣传册",
    dlFloorPlans: "下载平面图",
    fullName: "姓名 *",
    emailAdd: "电子邮箱 *",
    phoneNum: "电话号码",
    reqDesc: "填写您的详细信息以接收 {name} 的完整项目 {type}。",
    reqSuccess: "请求已收到",
    reqSuccessDesc: "谢谢。我们的专家将很快通过电子邮件将宣传册和平面图发送给您。",
    close: "关闭",
    submitting: "提交中...",
    reqType: "请求 {type}",
    types: {
        Apartment: "公寓",
        Townhouse: "联排别墅",
        Villa: "别墅",
        Penthouse: "顶层公寓",
        Mansion: "豪宅",
        Duplex: "复式公寓",
        Plot: "地块"
    },
    tags: {
        waterfront: "海滨",
        family: "家庭",
        luxury: "奢华",
        investment: "投资",
        golf: "高尔夫球场",
        urban: "城市",
        nature: "自然"
    },
    beds: {
        studio: "开间",
        br: "卧室",
        units: "单位",
        various: "多种"
    }
}
,
  offplanExtra: {
        "interested": "感兴趣吗？",
        "readyToSecure": "准备好预订您的单位于",
        "advisorGuide": "我们的专业顾问可以为您提供定价、付款方式和整个购买流程的指导——零佣金。",
        "getInTouch": "取得联系",
        "whatsapp": "WhatsApp",
        "enquire": "咨询",
        developer: "开发商",
    community: "社区",
    buildingHeight: "建筑高度",
    retailSpace: "零售空间",
    furnishing: "家具",
    about: "关于",
    investmentOutlook: "投资前景",
    lifestyle: "生活方式",
    worldClassAmenities: "世界级设施",
    unitTypes: "单位类型",
    floorPlans: "平面图",
    financing: "融资",
    typesSuffix: "类型",
    sizeRange: "面积范围",
    units: "单位",
    from: "起",
        ofTotalPayment: "占总付款的比例",
        whyOffPlan: "为什么选择期房？",
        lowerEntryPrice: "与现房相比入门价格更低",
        spreadPayments: "在施工期间分期付款",
        capitalAppreciation: "交房前资本增值",
        zeroCommission: "0% 佣金 — 直接购买",
        speakToAdvisor: "与顾问交流",
        openMap: "在 Google 地图中打开精确位置",
        nearbyPlaces: "附近地点",
        to: "到",
        booking: "预订",
        installment: "分期付款",
        handover: "交房",
        areaUnit: "面积单位",
        currency: "货币",
        youtubeLink: "YouTube 视频链接",
        watchVideo: "观看视频",
        watchTour: "观看房产导览"
    },
  amenities: {
        "Kids Pool": "儿童泳池",
        "Private Beach Access": "私人海滩通道",
        "Marina Access": "码头通道",
        "Outdoor Gym": "室外健身房",
        "Basketball Court": "篮球场",
        "Tennis Court": "网球场",
        "Padel Court": "板网球场",
        "Cycling Track": "自行车道",
        "Spa & Wellness Center": "水疗及康体中心",
        "Kids Play Area": "儿童游乐区",
        "Clubhouse": "会所",
        "Library": "图书馆",
        "Retail Outlets": "零售店",
        "Cafes & Restaurants": "咖啡馆和餐厅",
        "Supermarket": "超市",
        "Concierge Service": "礼宾服务",
        "24/7 Security": "24/7全天候保安",
        "CCTV Surveillance": "闭路电视监控",
        "Mosque": "清真寺",
        "Pet Friendly": "宠物友好",
        "Dining Destinations": "餐饮胜地",
        "Yoga Studio": "瑜伽工作室",
        "Lush Green Parks": "郁郁葱葱的公园",
        "Valet Parking": "代客泊车",
        "Smart Home Features": "智能家居设施",
        "Sauna & Steam Room": "桑拿及蒸汽室",
        "Covered Parking": "室内停车场",
        "Landscaped Gardens": "景观花园",
    "Swimming Pool": "游泳池",
    "State-of-the-art Gym": "先进健身房",
    "BBQ Area": "烧烤区",
    "Sports Courts": "运动场",
    "Infinity Pool": "无边际泳池",
    "Running Track": "跑道",
    "Cinema Room": "电影室",
    "Games Room": "游戏室"
}
}

export default zh
